import temaPadrao from "_config/temas/estilo/base";
import React, { ReactNode } from "react";
import {
  Form,
  FormControl,
  FormControlProps,
  InputGroup,
} from "react-bootstrap";

interface CustomInputProps extends FormControlProps {
  iconeEsquerdo?: ReactNode;
  iconeDireito?: ReactNode;
  iconeDireitoInterno?: ReactNode;
  iconeDireitoExterno?: ReactNode;
  sucesso?: boolean;
  noBoxShadow?: boolean;
  mensagemErro?: string | any;
  styleIconeEsquerdo?: React.CSSProperties;
  validar?: boolean;
  onClickMostrarSenha?: () => void;
  paddingIcon?: boolean;
  rows?: number;
}

export const CustomInput: React.FC<CustomInputProps> = React.forwardRef(
  (
    {
      iconeEsquerdo,
      iconeDireito,
      iconeDireitoInterno,
      iconeDireitoExterno,
      sucesso,
      noBoxShadow,
      mensagemErro,
      styleIconeEsquerdo,
      validar,
      onClickMostrarSenha,
      value,
      paddingIcon = false,
      ...props
    }: CustomInputProps,
    ref
  ) => {
    return (
      <InputGroup>
        {iconeEsquerdo && (
          <InputGroup.Text
            className="bg-white"
            style={{
              ...(mensagemErro && validar
                ? { borderColor: temaPadrao.colors.danger.main }
                : {
                    borderColor: `${
                      props.isValid || sucesso ? "green" : "#CED4DA"
                    }`,
                  }),
              ...styleIconeEsquerdo,
            }}
          >
            {iconeEsquerdo}
          </InputGroup.Text>
        )}
        <FormControl
          style={{
            borderRadius: "5px",
            ...(noBoxShadow ? { boxShadow: "none" } : null),
            ...(mensagemErro && validar
              ? { borderColor: temaPadrao.colors.danger.main }
              : {
                  borderColor: `${
                    props.isValid || sucesso ? "green" : "#CED4DA"
                  }`,
                }),
          }}
          value={value}
          {...props}
          ref={ref}
        />
        {iconeDireitoExterno}
        {iconeDireitoInterno && (
          <InputGroup.Text
            className="bg-white pointer"
            style={{
              padding: paddingIcon ? "17px 0px 17px 24px" : "",
              ...(mensagemErro && validar
                ? { borderTopColor: temaPadrao.colors.danger.main, borderBottomColor: temaPadrao.colors.danger.main }
                : {
                    borderTopColor: `${
                      props.isValid || sucesso ? "green" : "#CED4DA"
                    }`,
                    borderBottomColor: `${
                      props.isValid || sucesso ? "green" : "#CED4DA"
                    }`,
                  }),
            }}
          >
            {iconeDireitoInterno}
          </InputGroup.Text>
        )}
        {iconeDireito && (
          <InputGroup.Text
            className="bg-white pointer"
            style={{
              padding: paddingIcon ? "17px 24px 17px 8px" : "",
              borderTopRightRadius: "5px",
              borderBottomRightRadius: "5px",
              cursor: "pointer",
              ...(mensagemErro && validar
                ? {
                    borderTopColor: temaPadrao.colors.danger.main,
                    borderBottomColor: temaPadrao.colors.danger.main,
                    borderRightColor: temaPadrao.colors.danger.main,
                    borderLeftStyle: "none",
                  }
                : {
                    borderTopColor: `${
                      props.isValid || sucesso ? "green" : "#CED4DA"
                    }`,
                    borderBottomColor: `${
                      props.isValid || sucesso ? "green" : "#CED4DA"
                    }`,
                    borderRightColor: `${
                      props.isValid || sucesso ? "green" : "#CED4DA"
                    }`,
                    borderLeftStyle: "none",
                  }),
            }}
            onClick={onClickMostrarSenha}
          >
            {iconeDireito}
          </InputGroup.Text>
        )}
        {mensagemErro && (
          <Form.Control.Feedback
            type="invalid"
            style={{
              fontSize: "0.85rem",
              color: temaPadrao.colors.danger.main,
            }}
          >
            {mensagemErro}
          </Form.Control.Feedback>
        )}
      </InputGroup>
    );
  }
);
